import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { saveAs } from "file-saver";
import { confirmAlert } from "react-confirm-alert";
import { sortableHandle } from "react-sortable-hoc";
import {
  fetchSurveyResponse,
  changeSurveyFormStatus,
  deleteSurveyForm,
} from "SurveyAction";
import {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  formEdited,
} from "FormBuilderAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE, BASE_IMAGES_URL } from "Constants";
import AppIcons from "AppIcons";
import LocaleStrings from "Languages";

const DragHandle = sortableHandle(() => (
  <span className="drag-icon" style={{ cursor: "move" }}>
    <i className="fa fa-bars mx-6" aria-hidden="true"></i>
  </span>
));

class SurveyListItem extends Component {
  constructor(props) {
    super(props);
  }

  editForm(item) {
    // console.log("item :- ", item);
    let formNameEdit = item.formname;
    let newObj = JSON.parse(item.formjson);
    let formtype = item.formtype;
    let fixedObj = [];

    this.props.dynamicFormModal({
      key: "edit",
      showModal: true,
      category: formtype,
      fixedFields: fixedObj,
      formDetails: item,
    });
    this.props.updateFomeName(formNameEdit); // Form Name
    this.props.updateFormList(newObj, [], "samearray"); // Updating redux with editing from json
    this.props.formEdited(false); // This is used for edit form
  }

  /* Download Zip */
  handleClick = () => {
    let { session, listItem } = this.props;
    // Creating the survey response array

    this.props.fetchSurveyResponse(session, listItem, (fetchResponse) => {
      // Responce is ok
      if (fetchResponse.error === 0) {
        var surveyresponseGroup = fetchResponse?.data?.surveyresponsegroup;
        // console.log("surveyresponseGroup :- ", surveyresponseGroup);
        var multiarray = {};
        let noOfResponse = 0;
        _.map(surveyresponseGroup, function (gropuRes, key) {
          var finalarray = [];

          _.map(gropuRes, (res) => {
            noOfResponse++;

            var object = {};
            var response = JSON.parse(res.responses);
            // console.log("response :- ", response);

            _.map(response, (obj) => {
              if (
                obj.key !== "hyperlink" &&
                obj.key !== "label" &&
                obj.key !== "paragraph"
              ) {
                var correctValue = "";
                if (
                  (obj.key == "radiobuttons" || obj.key == "dropdown") &&
                  obj.value != ""
                ) {
                  // => object for 'radiobuttons'
                  var radiobuttonsMatchedObject = _.find(obj.options, {
                    value: obj.value,
                  });
                  correctValue = !_.isEmpty(radiobuttonsMatchedObject)
                    ? radiobuttonsMatchedObject.text
                    : "";
                } else if (obj.key == "checkboxes" && obj.value.length > 0) {
                  let checkboxvalue = obj.value;

                  if (typeof checkboxvalue === "string") {
                    if (checkboxvalue.indexOf("[") !== -1) {
                      // remove '[' ']' from string

                      let result = checkboxvalue.substring(
                        1,
                        checkboxvalue.length - 1
                      );
                      let splitVal = result.split(",");
                      let finalVal = splitVal.map((element) => {
                        return element.trim();
                      });

                      checkboxvalue = finalVal;
                    } else {
                      let splitVal = checkboxvalue.split(",");
                      let finalVal = splitVal.map((element) => {
                        return element.trim();
                      });

                      checkboxvalue = finalVal;
                    }
                  }

                  // // For check box
                  var checkboxesStringArr = [];
                  _.map(obj.options, (rowoption) => {
                    if (checkboxvalue.includes(rowoption.value)) {
                      checkboxesStringArr.push(rowoption.text);
                    }
                  });
                  correctValue = _.join(checkboxesStringArr, ",");
                } else {
                  // Input types text/number/paragraph and all
                  correctValue = obj.value;
                }

                object["Submitted By"] = res.username
                  ? res.username
                  : "Anonymous";

                object["Email"] = res.email ? res.email : "";

                object[obj.label] = correctValue;
              }
            });

            // debugger

            finalarray.push(object);
          }); // First map ends

          multiarray[key] = finalarray;
        });

        if (Object.keys(multiarray).length > 0) {
          this.JSONToCSVConvertor(multiarray, noOfResponse, true).bind();
        } else {
          this.props.showError(LocaleStrings.no_data_found);
        }
      } else {
        this.props.showError(LocaleStrings.content_something_wrong);
      }
    });
  };

  handlePublished = () => {
    var { session, listItem, currentPage, pageDataLength } = this.props;
    let pageNo = currentPage;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }
    let option = 1;
    let message = LocaleStrings.polls_qa_survey_alert_published;
    if (listItem.ispublished == 1) {
      option = 0;
      message = LocaleStrings.polls_qa_survey_alert_unpublished;
    }
    var value = { ispublished: option };

    this.props.changeSurveyFormStatus(
      session,
      value,
      listItem.formnumber,
      (response) => {
        if (response.success) {
          this.props.showSuccess(message);
          this.props.pagination(pageNo);
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  handleMandatory = () => {
    var { session, listItem, currentPage, pageDataLength } = this.props;
    let pageNo = currentPage;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }
    let option = 1;
    let message = LocaleStrings.polls_qa_survey_alert_mandatory;
    if (listItem.ismandatory == 1) {
      option = 0;
      message = LocaleStrings.polls_qa_survey_alert_not_mandatory;
    }
    var value = { ismandatory: option };

    this.props.changeSurveyFormStatus(
      session,
      value,
      listItem.formnumber,
      (response) => {
        if (response.success) {
          this.props.showSuccess(message);
          this.props.pagination(pageNo);
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  delete = () => {
    var { session, listItem, currentPage, pageDataLength } = this.props;
    let pageNo = currentPage;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    confirmAlert({
      title: LocaleStrings.delete,
      message: LocaleStrings.polls_qa_survey_text_delete_subtitle,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteSurveyForm(
              session,
              listItem.formnumber,
              (result) => {
                if (result.success) {
                  this.props.showSuccess(
                    LocaleStrings.polls_qa_survey_delete_success
                  );
                  this.props.pagination(pageNo);
                  this.props.contentBoardStatus();
                } else {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    let { listItem } = this.props;
    let published = false;
    let mandatory = false;
    if (listItem.ispublished == 1) {
      published = true;
    }
    if (listItem.ismandatory == 1) {
      mandatory = true;
    }

    return (
      <div
        // className="row"
        style={{
          fontWeight: "normal",
          color: "rgb(63,68,88)",
          borderTop: "1px solid #e6edf3",
          // padding: "10px 0",
          //cursor: "move",
        }}
      >
        <Container fluid>
          <Row style={{ alignItems: "center" }}>
            <Col className="vcenter p-10">
              <DragHandle />

              {listItem.formname}
            </Col>
            <Col className="vcenter">{listItem.totalresponse}</Col>
            <Col className="vcenter">
              <div className="vertical-align-center">
                <div
                  className="vertical-align-center"
                  style={{ position: "relative" }}
                >
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={() => this.handlePublished()}
                      checked={published}
                    />
                    <span className={`switch-slider switch-round`}></span>
                  </label>
                </div>
              </div>
            </Col>
            <Col className="vcenter">
              {" "}
              <div
                className="vertical-align-center"
                style={{ position: "relative" }}
              >
                <label className="switch-button-container">
                  <input
                    type="checkbox"
                    onChange={() => this.handleMandatory()}
                    checked={mandatory}
                  />
                  <span className={`switch-slider switch-round`}></span>
                </label>
              </div>
            </Col>
            <Col className="vcenter">
              {" "}
              <div className="vertical-align-center">
                <div className="" style={{ marginRight: "5px" }}>
                  <button
                    type="button"
                    className="btn btn-custom-table-blue"
                    onClick={() => this.editForm(listItem)}
                  >
                    <i className="fa fa-pencil i-custom-ms"></i>
                    {LocaleStrings.button_edit}
                  </button>
                </div>{" "}
                <div className="mr-5">
                  <button
                    className="i-custom-table-delete"
                    onClick={() => this.delete()}
                  >
                    <img
                      className="button-delete-icon"
                      src="../../style/images/delete.png"
                    />
                  </button>
                </div>
                <button
                  id={listItem.versionno}
                  type="button"
                  className="i-custom-table-theme"
                  onClick={() => this.handleClick()}
                >
                  <div className="font-icomoon text-custom-theme">
                    {AppIcons.downloadicon}
                  </div>
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  // Export to json
  JSONToCSVConvertor(JSONData, noOfResponse, ShowLabel) {
    // if (typeof XLSX == "undefined")

    var XLSX = require("xlsx");
    var zip = require("jszip")();

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();

    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);

      // var ws1 = XLSX.utils.json_to_sheet(JSONData['F2(149426)']);

      //var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      // XLSX.utils.book_append_sheet(wb, ws1, "F2(149426)");
    });

    /* bookType can be any supported output type */
    var wopts = { bookType: "xlsx", bookSST: false, type: "array" };

    var wbout = XLSX.write(wb, wopts);

    //var zip = new JSZip();
    zip.file("Survey_Response(" + noOfResponse + ").xlsx", wbout);
    // var img = zip.folder("images");
    // img.file("smile.gif", imgData, {base64: true});
    zip.generateAsync({ type: "blob" }).then(function (content) {
      saveAs(content, "Survey_Response(" + noOfResponse + ").zip");
    });
  }
}

export var mapStateToProps = (state) => {
  var surveyresponsedata =
    Object.keys(state.surveyResponseData).length === 0
      ? {}
      : state.surveyResponseData;

  return {
    session: state.session,
    surveyresponsedata,
  };
};
export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchSurveyResponse,
  changeSurveyFormStatus,
  deleteSurveyForm,
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  formEdited,
})(SurveyListItem);
